import React from 'react';
import ActionButton from './ActionButton';

export default function RemoveButton(props) {
    const tooltip = 'This app was added by your Admin. You cannot remove it.';

    return <ActionButton alias="delete" disabledTooltip={tooltip} {...props} />;
}
